import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ThemeProvider from "./theme/ThemeProvider";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import AuthRoute from "./auth/AuthRoute";

import PageSkeleton from "./components/Skeleton/PageSkeleton";

import "./App.css";

// Admin Layout
const AdminLayout = lazy(() => import("./admin/AdminLayout"));

// Admin Pages
const Dashboard = lazy(() => import("./admin/Dashboard"));
const Profile = lazy(() => import("./admin/Profile"));
const Settings = lazy(() => import("./admin/Settings"));
const UserControl = lazy(() => import("./admin/UserControl"));

// Paid Course Pages
const CreatePaidCourse = lazy(() => import("./admin/paid-course/CreatePaidCourse"));
const PaidCourseList = lazy(() => import("./admin/paid-course/PaidCourseList"));
const EditPaidCourse = lazy(() => import("./admin/paid-course/EditPaidCourse"));

const EnrollUserControl = lazy(() => import("./admin/EnrollUserControl"));


// Public Pages
const Home = lazy(() => import("./pages/Home"));
const Unauthorized = lazy(() => import("./pages/Unauthorized"));
const AccountSuspended = lazy(() => import("./pages/AccountSuspended"));

// Auth Pages
const SignIn = lazy(() => import("./auth/SignIn"));
const ForgotPassword = lazy(() => import("./auth/ForgotPassword"));

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Suspense fallback={<PageSkeleton />}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/account-suspended" element={<AccountSuspended />} />
              
              {/* Auth Routes */}
              <Route 
                path="/auth/sign-in" 
                element={
                  <AuthRoute>
                    <SignIn />
                  </AuthRoute>
                } 
              />
              <Route 
                path="/auth/forgot-password" 
                element={
                  <AuthRoute>
                    <ForgotPassword />
                  </AuthRoute>
                } 
              />
              
              {/* Admin Routes - Protected */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="settings" element={<Settings />} />
                <Route path="user-control" element={<UserControl />} />
                
                {/* Paid Course Routes */}
                <Route path="paid-course/create" element={<CreatePaidCourse />} />
                <Route path="paid-course/list" element={<PaidCourseList />} />
                <Route path="paid-course/edit/:id" element={<EditPaidCourse />} />
                <Route path="enroll-user-control" element={<EnrollUserControl />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;